import { requestGet } from '@/common/request';

export interface validTowerListParams {}

export interface validTowerListRes {}

//会场运营 - 查询当前登录用户的有效通天塔项目
export async function validTowerList(params?: validTowerListParams): Promise<validTowerListRes> {
  return await requestGet('/room/validTowerList', params);
}
